/**
 * Build-time environment configuration for PRODUCTION builds.
 * 
 * Client-specific values (Domain, API_ENDPOINT, ShowDomainTextbox, MSAL settings, Clarity project ID)
 * have been moved to runtime configuration (assets/config.json).
 * 
 * This allows building the application ONCE and deploying to multiple clients
 * by simply replacing the config.json file per deployment.
 */
export const environment = {
  /**
   * Indicates this is a production build.
   */
  production: true,

  /**
   * Application version (updated at build time).
   */
  Version: 'v2.96.5',

  /**
   * Default MSAL configuration template.
   * These values can be overridden at runtime via assets/config.json.
   */
  msalConfig: {
    auth: {
      clientId: 'a24c63ae-70ed-44a3-8543-7d9d64086b0e',
      authority: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
    },
  },

  /**
   * Default API configuration template.
   * The scopes can be overridden at runtime via assets/config.json.
   */
  apiConfig: {
    scopes: ['openid', 'profile', 'email'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },

  /**
   * Microsoft Clarity analytics configuration.
   * The enabled flag is global; projectId comes from runtime config.
   */
  clarity: {
    enabled: true,
  }
};

